var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.469 25.9633H15.6271L18.4324 23.1579H22.3469L23.1624 22.3424V18.3953L26.0004 15.59V14.4319L23.2113 11.6266V7.64685L22.3958 6.84765H18.4324L15.6271 4.05859H14.469L11.7452 6.84765H7.71658L6.85214 7.66316V11.6266L4.0957 14.4319V15.59L6.85214 18.3953V22.3424L7.71658 23.1579H11.7452L14.469 25.9633Z",
    fill: "#F4CF67"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3141_36539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8373 12.1937C18.6208 11.9354 18.2691 11.9355 18.0522 12.1937L14.5185 16.4032L12.9479 14.5323C12.7311 14.274 12.3795 14.274 12.1627 14.5323C11.9458 14.7907 11.9458 15.2094 12.1627 15.4677L14.1258 17.8062C14.2342 17.9353 14.3762 18 14.5184 18C14.6605 18 14.8027 17.9355 14.9111 17.8062L18.8373 13.1291C19.0542 12.8709 19.0542 12.452 18.8373 12.1937Z",
    fill: "#7C63A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3141_36539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 6,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.185f5d5e8ebb22a927a28e556b2c3277.svg";
export { ForwardRef as ReactComponent };